export function Secondary({ children, type, disabled = false, ...props }) {
    type = type || 'button'

    return (
        <button
            disabled={disabled}
            {...props}
            type={type}
            className={`p-2 px-4 rounded text-white font-medium w-52
                ${disabled ? 'bg-gray-300' : 'hover:bg-olh bg-olm'}
            `}>
            {children}
        </button>
    )
}
